module.exports = __webpack_public_path__ + "static/media/YB5F13_1.547fbe67.jpg";